(function ($) {
	$(document).ready(function ($) {
		let regionPath = $('.map__region');
		let ajax = $('#map-ajax').val();

		regionPath.click(function () {
			let regionSlug = $(this).data('region');
			if (!ajax) {
				window.location.href = `/region/${regionSlug}`;
			}
		});

		regionPath.mouseenter(function () {
			let regionSlug = $(this).data('region');
			let currentLabel = $(`.map__label[data-region="${regionSlug}"]`);
			currentLabel.addClass('show');
		});

		regionPath.mouseleave(function () {
			let regionSlug = $(this).data('region');
			let currentLabel = $(`.map__label[data-region="${regionSlug}"]`);
			currentLabel.removeClass('show');
		});
	});
})(jQuery);
